import { IconComponent } from './types';

const LocationIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={17}
    viewBox="0 0 12 17"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      d="M6.25 1A5.246 5.246 0 0 0 1 6.25C1 10.188 6.25 16 6.25 16s5.25-5.813 5.25-9.75A5.246 5.246 0 0 0 6.25 1Zm.05 7.65a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Z"
      clipRule="evenodd"
    />
  </svg>
);

export default LocationIcon;
